import React from 'react';
import { cn } from '../../../utils/cn';

const ProgressIndicator = ({ currentStep, totalSteps, estimatedTime }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-foreground">
          Stap {currentStep} van {totalSteps}
        </p>
        {estimatedTime && (
          <p className="text-sm text-muted-foreground">
            Geschatte tijd: {estimatedTime}
          </p>
        )}
      </div>
      <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="flex items-center justify-between">
        {Array.from({ length: totalSteps }, (_, i) => i + 1)?.map((step) => (
          <div
            key={step}
            className={cn(
              "flex items-center justify-center w-8 h-8 rounded-full text-xs font-medium transition-colors",
              step < currentStep && "bg-primary text-primary-foreground",
              step === currentStep && "bg-primary text-primary-foreground ring-2 ring-primary ring-offset-2",
              step > currentStep && "bg-muted text-muted-foreground"
            )}
          >
            {step}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;